import ListModeSelector from "./ListModeSelector";
import BasicButton from "./BasicButton";

interface PageTopSectionProps {
  title: string;
  onModeChange?: (event: React.ChangeEvent) => void;
  onClick?: (event: React.MouseEvent) => void | (() => void);
  buttonText?: string;
}

function PageTopSection({
  title,
  onModeChange,
  onClick,
  buttonText = "추가",
}: PageTopSectionProps) {
  return (
    <div className="flex items-center gap-3">
      {onModeChange && <ListModeSelector onChange={onModeChange} />}
      <p className="text-lg font-bold">{title}</p>
      {onClick && (
        <BasicButton
          text={buttonText}
          onClick={onClick}
          className="ml-auto w-fit"
        />
      )}
    </div>
  );
}

export default PageTopSection;
